import React from 'react';

const SpaceMascot: React.FC<{
  style?: React.CSSProperties;
  className?: string;
}> = ({ style, className }) => (
  <svg
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
    style={style}
    className={className}
  >
    <defs>
      <linearGradient id="space-visor" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#0a1628" />
        <stop offset="50%" stopColor="#67e8f9" />
        <stop offset="100%" stopColor="#0a1628" />
      </linearGradient>
      <filter id="space-glow">
        <feGaussianBlur stdDeviation="1.2" result="blur" />
        <feFlood floodColor="#67e8f9" floodOpacity="0.5" result="color" />
        <feComposite in="color" in2="blur" operator="in" result="glow" />
        <feMerge>
          <feMergeNode in="glow" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    {/* Helmet outline */}
    <circle cx="16" cy="17" r="11" fill="#c0c0c0" filter="url(#space-glow)" />
    <circle cx="16" cy="17" r="9.5" fill="#e8e8e8" />
    {/* Visor */}
    <circle cx="16" cy="17" r="7" fill="url(#space-visor)" />
    {/* Visor highlight */}
    <ellipse
      cx="13.5"
      cy="14.5"
      rx="2.5"
      ry="1.5"
      fill="white"
      opacity="0.25"
    />
    {/* Antenna stem */}
    <line
      x1="16"
      y1="6"
      x2="16"
      y2="2.5"
      stroke="#c0c0c0"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Antenna tip */}
    <circle cx="16" cy="2" r="1.5" fill="#67e8f9" />
  </svg>
);

export default SpaceMascot;
